<template>
  <div>
    <h3 v-if="filters.length">Filters</h3>
    <h3 v-else>No filters</h3>
    <div v-for="(f, i) in filters" :key="i">
      <v-btn class="mt-5" @click="go(f.name)">
        {{ f.name }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { formatMixin, listMixin } from "@/helpers/mixins";

export default {
  mixins: [formatMixin, listMixin],

  components: {},

  data() {
    return {
      filters: [],
    };
  },

  props: ["customer"],

  computed: {},

  created() {
    this.loadQtimes();
  },

  methods: {
    loadQtimes: function() {
      this.$store.dispatch("loading", true);
      axios
        .get(`/api/qtimes?customer=${this.customer}`)
        .then((res) => {
          this.filters = res.data;

          this.$store.dispatch("loading", false);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    go: function(filterName) {
      this.$router.push(`${this.$route.path}/${filterName}`);
    },
  },
};
</script>
